import { BASE_URL } from "./helper";

export const isAttachmentIconId = (value) =>
  typeof value === "string" && /^[a-f0-9]{24}$/i.test(value);

export const loadIcon = (iconId) => {
  if (!isAttachmentIconId(iconId)) return null;
  return `${BASE_URL}/attachments/${iconId}`;
};
